const LIGHT_TYPE = {
  Monitor: 'MONITOR',
}

export { LIGHT_TYPE };
